"use client";
import { IFeatureBoxes } from "@/api/AppApi/services/home/interfaces/IFeatureBox";
import { useIsMobile } from "@/hooks/useIsMobile";
import MobileFeatureBoxes from "./MobileFeatureBoxes";
import PCFeatureBoxes from "./PCFeatureBoxes";

interface Props extends IFeatureBoxes {}

const FeatureBoxes = (props: Props) => {
  const mobile = useIsMobile();
  if (mobile) return <MobileFeatureBoxes {...props} />;
  else return <PCFeatureBoxes {...props} />;
};

export default FeatureBoxes;
